export default __webpack_public_path__ + "static/media/white_email.370a8418.svg";